export { default } from "./golder-property"